(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-gold-bundle-engine"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mg-bundle]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const inputs = [...root.querySelectorAll('[data-bundle-item]')];
    const total = root.querySelector('[data-bundle-total]');
    const count = root.querySelector('[data-bundle-count]');
    const submit = root.querySelector('[data-bundle-submit]');
    const status = root.querySelector('[data-bundle-status]');
    const currency = document.documentElement.lang || 'en';
    const formatMoney = (cents) => new Intl.NumberFormat(currency, { style: 'currency', currency: window.Shopify?.currency?.active || 'EGP' }).format(cents / 100);
    const selected = () => inputs.filter((input) => input.checked);
    const update = () => {
      const chosen = selected();
      const cents = chosen.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
      count.textContent = `${chosen.length} ${chosen.length === 1 ? root.dataset.itemOne : root.dataset.itemMany}`;
      total.textContent = formatMoney(cents);
    };
    inputs.forEach((input) => input.addEventListener('change', update));
    submit?.addEventListener('click', async () => {
      submit.disabled = true;
      status.textContent = '';
      try {
        const items = selected().map((input) => ({ id: Number(input.dataset.variantId), quantity: 1 }));
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (error) {
        status.textContent = root.dataset.error;
        submit.disabled = false;
      }
    });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-gold-cart-growth"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cart-growth]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const status = root.querySelector('[data-cart-growth-status]');
    root.querySelectorAll('[data-cart-growth-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        button.disabled = true;
        status.textContent = '';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.reload();
        } catch (error) {
          status.textContent = 'Please try again.';
          button.disabled = false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-gold-product-conversion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const radio = event.target.closest('.mg-conversion-pdp__option-group input[type="radio"]');
    if (!radio) return;
    const section = radio.closest('.mg-conversion-pdp');
    const selected = Array.from(section.querySelectorAll('.mg-conversion-pdp__option-group input:checked')).map((input) => input.value);
    const select = section.querySelector('[data-variant-select]');
    if (!select) return;
    const option = Array.from(select.options).find((item) => item.dataset.options.split('||').every((value, index) => value === selected[index]));
    if (!option) return;
    select.value = option.value;
    const available = option.dataset.available === 'true';
    const mainPrice = section.querySelector('[data-main-price]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const stickyVariant = section.querySelector('[data-sticky-variant]');
    const mainAdd = section.querySelector('[data-main-add]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    if (mainPrice) mainPrice.textContent = option.dataset.price;
    if (stickyPrice) stickyPrice.textContent = option.dataset.price;
    if (stickyVariant) stickyVariant.value = option.value;
    if (mainAdd) mainAdd.disabled = !available;
    if (stickyAdd) stickyAdd.disabled = !available;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-gold-product-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const section = select.closest('.mg-pdp');
    const option = select.options[select.selectedIndex];
    const price = section && section.querySelector('[data-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-gold-revenue-engine"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.querySelector('[data-mg-revenue-engine]');if(!root)return;let list=[];try{list=JSON.parse(localStorage.getItem('mgRecentlyViewed')||'[]')}catch(e){list=[]}const current={id:root.dataset.productId,title:root.dataset.productTitle,url:root.dataset.productUrl,image:root.dataset.productImage,price:root.dataset.productPrice},prior=list.filter(x=>x.id!==current.id&&x.url&&x.image).slice(0,4),wrap=root.querySelector('[data-mg-recently-viewed]'),grid=root.querySelector('[data-mg-recently-viewed-grid]');if(prior.length&&wrap&&grid){prior.forEach(item=>{const a=document.createElement('a');a.className='mg-p9-card';a.href=item.url;a.dataset.mgTrack='recently_viewed_click';const img=document.createElement('img');img.src=item.image;img.alt=item.title;img.loading='lazy';img.width=600;img.height=750;const name=document.createElement('strong');name.textContent=item.title;const price=document.createElement('span');price.textContent=item.price;a.append(img,name,price);grid.append(a)});wrap.hidden=false;window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'view_item_list',item_list_name:'recently_viewed',items:prior.map((x,i)=>({item_id:x.id,item_name:x.title,index:i+1}))})}try{localStorage.setItem('mgRecentlyViewed',JSON.stringify([current,...list.filter(x=>x.id!==current.id)].slice(0,8)))}catch(e){}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-gold-social-personal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mg-social-personal]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const params = new URLSearchParams(window.location.search);
    const rawSource = (params.get('utm_source') || params.get('source') || '').toLowerCase();
    const rawCampaign = (params.get('utm_campaign') || params.get('campaign') || '').toLowerCase();
    const rawContent = (params.get('utm_content') || '').toLowerCase();
    const referrer = document.referrer.toLowerCase();
    const canStore = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    const key = 'missgold_social_attribution';
    let saved = {};
    if (canStore) {
      try { saved = JSON.parse(localStorage.getItem(key) || '{}'); } catch (error) { saved = {}; }
    }
    let source = rawSource || saved.source || '';
    if (!source && referrer.includes('instagram')) source = 'instagram';
    if (!source && referrer.includes('facebook')) source = 'facebook';
    if (!source && referrer.includes('tiktok')) source = 'tiktok';
    const campaign = rawCampaign || saved.campaign || '';
    const content = rawContent || saved.content || '';
    if (canStore && (rawSource || rawCampaign || rawContent)) {
      const attribution = { source, campaign, content, landing: window.location.pathname, timestamp: Date.now() };
      localStorage.setItem(key, JSON.stringify(attribution));
      saved = attribution;
    }
    const signal = `${source} ${campaign} ${content}`;
    let variant = '';
    if (signal.includes('gift')) variant = 'gift';
    else if (signal.includes('creator') || signal.includes('influencer')) variant = 'creator';
    else if (signal.includes('instagram') || signal.includes('ig')) variant = 'instagram';
    else if (signal.includes('facebook') || signal.includes('meta') || signal.includes('fb')) variant = 'facebook';
    else if (signal.includes('tiktok') || signal.includes('tt')) variant = 'tiktok';
    if (!variant) return;
    const title = root.dataset[`${variant}Title`] || root.dataset.defaultTitle;
    const text = root.dataset[`${variant}Text`] || root.dataset.defaultText;
    root.querySelector('[data-social-source]').textContent = source || variant;
    root.querySelector('[data-social-title]').textContent = title;
    root.querySelector('[data-social-text]').textContent = text;
    root.hidden = false;
    root.querySelector('[data-social-dismiss]')?.addEventListener('click', () => { root.hidden = true; });
    const detail = { source, campaign, content, variant, pageType: root.dataset.pageType };
    document.dispatchEvent(new CustomEvent('missgold:personalized_view', { detail }));
    if (canStore && root.dataset.pageType === 'cart' && source) {
      fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Campaign source': source, 'Campaign name': campaign || 'not set', 'Campaign content': content || 'not set' } })
      }).catch(() => {});
    }
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.action.includes('/cart/add')) document.dispatchEvent(new CustomEvent('missgold:social_add_to_cart', { detail }));
      if (event.submitter?.name === 'checkout') document.dispatchEvent(new CustomEvent('missgold:social_checkout_start', { detail }));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-gold-trust-gifting"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gift-toggle]').forEach((toggle) => {
    const form = toggle.closest('form');
    const fields = form?.querySelector('[data-gift-fields]');
    const sync = () => { if (fields) fields.hidden = !toggle.checked; };
    toggle.addEventListener('change', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();
})();
